// -didim_realty_world
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Layout from '@/pages/layout';

// Lazy load all pages for better performance and to trigger Suspense
const CustomPage = lazy(() => import('@/pages/CustomPage'));
const ErrorPage = lazy(() => import('@/pages/ErrorPage'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const Home = lazy(() => import('@/pages/Home'));
const Properties = lazy(() => import('@/pages/Properties'));
const PropertyDetail = lazy(() => import('@/pages/PropertyDetail'));
const AreaGuide = lazy(() => import('@/pages/AreaGuide'));
const AreaGuideDetail = lazy(() => import('@/pages/AreaGuideDetail'));
const BuyerGuide = lazy(() => import('@/pages/BuyerGuide'));
const About = lazy(() => import('@/pages/About'));
const ContactGetInTouch = lazy(() => import('@/pages/Contact/GetInTouch'));
const ContactMeetTheTeam = lazy(() => import('@/pages/Contact/MeetTheTeam'));
const AgentDetail = lazy(() => import('@/pages/Contact/AgentDetail'));
const Legal = lazy(() => import('@/pages/Legal'));
const AboutUs = lazy(() => import('@/pages/AboutUs'));
const Services = lazy(() => import('@/pages/Services'));
const BankInfo = lazy(() => import('@/pages/BankInfo'));
const BankDetail = lazy(() => import('@/pages/BankInfo/detail'));
const News = lazy(() => import('@/pages/News/news'));
const NewsDetail = lazy(() => import('@/pages/News/newsDetail'));
const Notifications = lazy(() => import('@/pages/Notification'));
const NotificationsDetail = lazy(() => import('@/pages/Notification/Detail'));
const Customer = lazy(() => import('@/pages/CustomerRep'));
const Contact = lazy(() => import('@/pages/Contact'));
const ContactForm = lazy(() => import('@/pages/ContactForm'));
const Navlun = lazy(() => import('@/pages/Form/navlun'));
const Sigorta = lazy(() => import('@/pages/Form/sigorta'));
const Blog = lazy(() => import('@/pages/Blog'));
const BlogDetail = lazy(() => import('@/pages/BlogDetail'));



export default [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/emlaklar/:slug',
        element: <Properties />
      },
      {
        path: '/emlak-detay/:slug',
        element: <PropertyDetail />
      },
      {
        path: '/alan-rehberi/:slug',
        element: <AreaGuideDetail />
      },
      {
        path: '/alici-rehberi/:slug',
        element: <BuyerGuide />
      },
      {
        path: '/hakkimizda',
        element: <About />
      },
      {
        path: '/iletisim/iletisime-gec',
        element: <ContactGetInTouch />
      },
      {
        path: '/iletisim/ekibimizle-tanisin',
        element: <ContactMeetTheTeam />
      },
      {
        path: '/iletisim/temsilci/:id',
        element: <AgentDetail />
      },
      {
        path: '/legal/:slug',
        element: <Legal />
      },
      // Turkish URLs for Legal pages
      {
        path: '/kurumsal/sartlar-ve-kosullar',
        element: <Legal />
      },
      {
        path: '/kurumsal/gizlilik-politikasi',
        element: <Legal />
      },
      // English URLs for Legal pages
      {
        path: '/terms-and-conditions',
        element: <Legal />
      },
      {
        path: '/privacy-policy',
        element: <Legal />
      },
      // Other corporate pages
      {
        path: '/kurumsal/:slug',
        element: <AboutUs />
      },
      {
        path: '/hizmetlerimiz/:slug',
        element: <Services />
      },
      {
        path: '/bilgibankasi',
        element: <BankInfo />
      },
      {
        path: 'bilgibankasi/:slug',
        element: <BankDetail />
      },
      {
        path: '/bizdenhaberler',
        element: <News />
      },
      {
        path: '/bizdenhaberler/:slug',
        element: <NewsDetail />
      },
      // {
      //   path: '/musteritemsilcisi',
      //   element: <Customer />
      // },
      {
        path: '/iletisim',
        element: <Contact />
      },
      {
        path: '/musterianketformu',
        element: <ContactForm />
      },
      {
        path: '/duyurular',
        element: <Notifications />
      },
      {
        path: '/navluntalepformu',
        element: <Navlun />
      },
      {
        path: '/sigortatalepformu',
        element: <Sigorta />
      },
      {
        path: '/duyurular/:slug',
        element: <NotificationsDetail />
      },
      {
        path: '/blog',
        element: <Blog />
      },
      {
        path: '/blog/:slug',
        element: <BlogDetail />
      },
      {
        path: "/test",
        element: <>Bu bir test sayfasıdır</>
      },

      //custom page
      {
        path: '*',
        element: <NotFound />
      },

      {
        path: '/404',
        element: <NotFound />
      }
    ]

  }
] as RouteObject[];
